import { ICellRenderer } from '@ag-grid-enterprise/all-modules';

import Account from '../model/Account';
import AccountsService from '../services/AccountsService';

class AccountCellRenderer implements ICellRenderer {
	private eGui: HTMLElement;
	private value: string;

	private AccountsService: AccountsService;

	constructor() {
		this.eGui = document.createElement('div');
		this.eGui.innerHTML = '';

		this.AccountsService = new AccountsService();
		this.value = '';
	}

	public init(params: any) {
		this.value = params.value;

		if (this.value) {
			this.AccountsService.getById(this.value).then((data) => {
				if (data) {
					this.eGui.innerHTML = new Account(data).displayAggrid();
				} else {
					this.eGui.innerHTML = '-';
				}
			}).catch(() => {
				this.eGui.innerHTML = '-';
			});
		} else {
			this.eGui.innerHTML = '-';
		}
	}

	public getGui() {
		return this.eGui;
	}

	public refresh() {
		return false;
	}
}

export default AccountCellRenderer;
